import { useLocalSearchParams } from 'expo-router';
import TeamPersonUpdate from '@/screens/TeamPersonUpdate';

export default function PrivateTeamTeamIdMemberPersonIdEditIndexRoute() {
  const { personId, teamId } = useLocalSearchParams<{
    personId: string;
    teamId: string;
  }>();

  return (
    <TeamPersonUpdate
      key={`${teamId}:${personId}`}
      personId={personId}
      teamId={teamId}
    />
  );
}
